import type { OntologyEntry } from '../types.js';

export const industries: OntologyEntry[] = [
  { slug: 'financial-services', name: 'Financial Services', dimension: 'industry', sortOrder: 0 },
  { slug: 'healthcare', name: 'Healthcare', dimension: 'industry', sortOrder: 1 },
  { slug: 'technology', name: 'Technology', dimension: 'industry', sortOrder: 2 },
  { slug: 'manufacturing', name: 'Manufacturing', dimension: 'industry', sortOrder: 3 },
  { slug: 'retail', name: 'Retail', dimension: 'industry', sortOrder: 4 },
  { slug: 'energy-utilities', name: 'Energy & Utilities', dimension: 'industry', sortOrder: 5 },
  { slug: 'government', name: 'Government', dimension: 'industry', sortOrder: 6 },
  { slug: 'education', name: 'Education', dimension: 'industry', sortOrder: 7 },
  { slug: 'telecom', name: 'Telecommunications', dimension: 'industry', sortOrder: 8 },
  { slug: 'critical-infrastructure', name: 'Critical Infrastructure', dimension: 'industry', sortOrder: 9 },
  { slug: 'professional-services', name: 'Professional Services', dimension: 'industry', sortOrder: 10 },
  { slug: 'media-entertainment', name: 'Media & Entertainment', dimension: 'industry', sortOrder: 11 },
];
